var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoColorantesOrConservatives(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 47.34A52.66 52.66 0 10152.66 100 52.72 52.72 0 00100 47.34zm0 6.88a45.55 45.55 0 0130.16 11.38L65.6 130.16A45.75 45.75 0 01100 54.22zm0 91.56A45.57 45.57 0 0170.51 135L135 70.51a45.75 45.75 0 01-35 75.27z"
  })));
}
export default SvgNoColorantesOrConservatives;